import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { InlineMessage, InlineMessageProps } from 'src/InlineMessage';

import useStyles from './styles';

export interface InlineMessageWithTransitionProps extends InlineMessageProps {
  margin: string;
}

export const InlineMessageWithTransition: FC<InlineMessageWithTransitionProps> = ({
  message,
  margin,
  ...otherProps
}) => {
  const classes = useStyles({ margin });

  return (
    <TransitionGroup component={null}>
      {message && (
        <CSSTransition classNames={{ ...classes }} timeout={300}>
          <Grid container>
            <InlineMessage message={message} {...otherProps} />
          </Grid>
        </CSSTransition>
      )}
    </TransitionGroup>
  );
};
